<template>
  <div :class="headingClass">
    <h1 v-if="type === '1'">
      <slot></slot>
    </h1>
    <h2 v-if="type === '2'">
      <slot></slot>
    </h2>
    <h3 v-if="type === '3'">
      <slot></slot>
    </h3>
    <h4 v-if="type === '4'">
      <slot></slot>
    </h4>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: '1',
    },
    display: {
      type: Boolean,
      deafult: false,
    }
  },
  computed: {
    headingClass() {
      return this.display ? 'Heading Heading--display' : 'Heading'
    },
  },
}
</script>

<style scoped>
.Heading {
  font-weight: 700;
}

.Heading--display {
  font-size: 1.44em;
}

.Heading--display > * {
  font-weight: 300;
}
</style>





// WEBPACK FOOTER //
// src/components/Heading/Heading.vue